// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"104":"9545600b","882":"f3cad92c","937":"e654eee1"}[chunkId] + ".js";
};